import React from 'react';
export function InfoGrid({
  items,
  cols = 3
}: {
  items: [string, React.ReactNode][];
  cols?: 2 | 3 | 4;
}) {
  const grid = {
    2: 'sm:grid-cols-2',
    3: 'sm:grid-cols-2 lg:grid-cols-3',
    4: 'sm:grid-cols-2 lg:grid-cols-4'
  }[cols];
  return <dl className={`grid gap-x-6 gap-y-4 ${grid}`} data-id="element-84" data-mp="1jsk2udzuo8w8">
      {items.map(([k, v]) => <div key={k} className="min-w-0" data-id="element-85" data-mp="1eu8u66lak4fl">
          <dt className="text-xs text-ink-muted" data-id="element-86" data-mp="1evbic6r8bsrt">{k}</dt>
          <dd className="mt-0.5 break-words text-sm font-semibold text-ink" data-id="element-87" data-mp="2cfedkj6v7twi">{v || '—'}</dd>
        </div>)}
    </dl>;
}